<template>
  <div class="animated fadeIn">
    <component-header
      title="Unit Management"
      :isLoading="loading"
      :hasReload="false"
      :hasSearch="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.go(-1)"
    />
    <b-card>
      <b-row>
        <b-col md="12" v-for="(unit, index) in units" :key="index">
          <unitCard :unitInfo="unit" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import unitCard from "@/components/cardView/unitCard.vue";
export default {
  components: {
    ComponentHeader,
    unitCard,
  },
  data() {
    return {
      loading: false,
      units: null,
    };
  },
  methods: {
    async unitList() {
      const payload = {
        id: '66fa140f6a471d55dac5177b',
        bath: this.$route.params.bath,
        bed: this.$route.params.bed,
        page: 1,
      };
      await this.$store.dispatch("unit/fetchUnitDetails", payload).then((res) => {
        this.units = res;
      });
    },
  },
  mounted() {
    this.unitList();
  },
};
</script>
